export const CARD_TITLE = 'Дом, 216 м², 6 сот., ИЖС';

export const CARD_PRICE = '12 345 678 ₽';

export const ROSREESTR_DATA = [
  {
    header: 'Об участке',
    elements: [
      { title: 'Категория земель', value: 'Земли населённых пунктов' },
      { title: 'Разрешённое использование', value: 'Под индивидуальный жилой дом' },
      { title: 'Собственность', value: 'Единоличная с 19.09.2021' },
      { title: 'Площадь', value: '6 сот.' },
      { title: 'Кадастровая стоимость', value: '8 000 745,67 ₽' },
      { title: 'Адрес', value: 'Московская область, Истра городской округ, Чесноково деревня, д.***' },
      { title: 'Последнее обновление', value: '12.12.2012' },
    ],
  },
  {
    header: 'О здании',
    elements: [
      { title: 'Тип здания', value: 'Дом' },
      { title: 'Собственность', value: '1/2 собственности с 19.09.2021\n1/2 собственности с 19.09.2021' },
      { title: 'Площадь', value: '216 м2' },
      { title: 'Этажность', value: '1' },
      { title: 'Кадастровая стоимость', value: '8 000 745,67 ₽' },
      { title: 'Последнее обновление', value: '19.09.2019' },
    ],
  },
];
